import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import SidebarContent from "./SidebarContent";

const Sidebar = styled(({ el, data }) => {
  return ReactDOM.createPortal(<SidebarContent data={data} />, el);
})`
  background: rgba(0, 0, 0, 0.5);
  padding: 1.5em;
  width: 20vw &.mapboxgl-ctrl {
    margin-left: 0;
    margin-top: 0;
  }

  h1 {
    margin-top: 0;
    font-family: merriweather, serif;
    line-height: 1.2;
  }

  p:last-child {
    margin-bottom: 0;
  }

  .toggle {
    display: inline-block;
    padding: 0 0.5em;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    text-decoration: none;
    color: black;
  }

  .toggle:hover {
    background: white;
  }
`;

export default Sidebar;
